import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { optInPostHog, optOutPostHog } from '../services/analytics/posthog';

export const CookieConsentBanner: React.FC = () => {
  return (
    <CookieConsent
      location="bottom"
      cookieName="autar-analytics-consent"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={() => {
        optInPostHog();
        window.dispatchEvent(new Event('cookie-consent-resolved'));
      }}
      onDecline={() => {
        optOutPostHog();
        window.dispatchEvent(new Event('cookie-consent-resolved'));
      }}
      style={{
        background: 'hsl(var(--card))',
        borderTop: '1px solid hsl(var(--border))',
        alignItems: 'center',
        padding: '0.875rem 1.5rem',
        zIndex: 9998,
      }}
      contentStyle={{
        margin: 0,
        flex: 1,
        fontSize: '0.875rem',
        color: 'hsl(var(--muted-foreground))',
      }}
      buttonWrapperClasses="flex items-center gap-2 ml-6 shrink-0"
      buttonStyle={{
        background: 'var(--color-accent-teal)',
        color: '#fff',
        fontSize: '0.8125rem',
        fontWeight: 500,
        padding: '0.4375rem 1rem',
        borderRadius: '0.375rem',
        margin: 0,
        cursor: 'pointer',
      }}
      declineButtonStyle={{
        background: 'transparent',
        border: '1px solid hsl(var(--border))',
        color: 'hsl(var(--muted-foreground))',
        fontSize: '0.8125rem',
        fontWeight: 500,
        padding: '0.4375rem 1rem',
        borderRadius: '0.375rem',
        margin: 0,
        cursor: 'pointer',
      }}
    >
      We use analytics to improve your experience. See our privacy policy for details.
    </CookieConsent>
  );
};
